// extracted by mini-css-extract-plugin
export var containerHomepage = "styles-module--containerHomepage--H5l+6";
export var containerSubpage = "styles-module--containerSubpage--eTE9n";
export var hl = "styles-module--hl--AC+nm";
export var img = "styles-module--img--TWcAK";
export var leftCol = "styles-module--leftCol--dZdnz";
export var text = "styles-module--text--iSaWt";
export var video = "styles-module--video--W2NzK";
export var wrapper = "styles-module--wrapper--c-owL";